import React from 'react'
import { Link } from 'react-router-dom'
import UseScrollReveal from '../Common/UseScrollReveal '

const HomeLocation = () => {
    UseScrollReveal();
    return (
        <>
            <section className='location-wrap d-flex align-items-center'>
                <div className='w-50 location-left d-flex align-items-center'>
                    <div className='w-100'>
                        <div className='mxw-660 ms-auto'>
                            <h2 className='main-title text-start mb-1 text-uppercase reveal wow fadeIn'>Location</h2>
                            <h4 className='lb-title1 mb-1 reveal wow fadeIn'>McLaren Orlando LLC</h4>
                            <p className='reveal wow fadeIn'>1111 S Orlando Ave <br/>
                            Winter Park, FL 32789</p>
                            <div className='md-title text-start fw-bold mt-4 mb-5 reveal wow fadeIn'>407-988-0111</div>
                            <Link to="/contact" className='theme-btn text-uppercase d-inline-block reveal wow fadeIn'>Make an Appointment</Link>
                        </div>
                    </div>
                </div>
                <div className='w-50'>
                    <iframe className='ci-iframe' src="https://snazzymaps.com/embed/692451" width="100%" height="494px" ></iframe>
                </div>
            </section>
        </>
    )
}

export default HomeLocation